"use client";

import * as React from "react";
import { motion } from "framer-motion";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function EmotionalClosing() {
  return <section id="emotionalclosingcta" className="bg-background py-16 md:py-24 px-6 md:px-10 lg:px-24 flex flex-col items-center justify-center text-center overflow-hidden">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.4
    }} transition={{
      duration: 1,
      ease: [0.16, 1, 0.3, 1]
    }} className="max-w-3xl mx-auto flex flex-col items-center">
        <h2 className="text-3xl text-foreground mb-8 leading-tight !font-serif md:text-4xl lg:text-5xl"><span className="!font-sans"><span className="!font-serif">Tu n'as pas à vivre ton post-partum seule.</span></span></h2>
        
        <p className="text-lg md:text-xl font-sans text-foreground/80 mb-12 max-w-2xl mx-auto leading-relaxed">Six semaines pour souffler, créer du lien et te sentir entourée.</p>

        <Button asChild size="lg" className="bg-destructive text-destructive-foreground hover:bg-destructive/90 rounded-lg px-10 py-7 text-lg shadow-md hover:shadow-lg transition-all duration-500 hover:scale-105">
          <Link href="#pied-de-page">Je m'inscris!</Link>
        </Button>
      </motion.div>
    </section>;
}